import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { css } from "styled-components";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import getColor from "@insite/mobius/utilities/getColor";
import Zone from "@insite/client-framework/Components/Zone";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";

const enum fields {
  title = "title",
  image = "image",
  linkTo = "linkTo",
  icon = "icon",
}

interface OwnProps extends WidgetProps {
  fields: {
    [fields.title]: string;
    [fields.image]: string;
    [fields.icon]: string;
    [fields.linkTo]: {
      type: string;
      value: string;
    };
  }
}

interface JoinTeamAndPodcasts {
    wrapper?: InjectableCss;
    joinTeamContainer?: InjectableCss;
    PodcastsContainer?: InjectableCss;
}

export const styles: JoinTeamAndPodcasts = {
    wrapper: {
        css: css`
            display: flex;
            align-items: center;
            gap: 22px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding-right: 1rem;
                            padding-left: 1rem;
                            max-width: 100%;
                            flex-direction: column;
                            padding: 60px 1rem;
                        `,
                        null,
                        null,
                        css`
                            padding: 60px 80px;
                            flex-direction: row;
                        `,
                    ],
                    "min",
                )}
        `,
    },
    joinTeamContainer: {
      css: css`
        flex: 1;
        flex-shrink: 0;
        background: #E6E1E8;
        border-radius: 10px;
        padding: 35px 40px;
        align-self: stretch;
      `
    },
    PodcastsContainer: {
      css: css`
        flex: 1;
        flex-shrink: 0;
        background: #E6E1E8;
        border-radius: 10px;
        padding: 35px 20px;
        align-self: stretch;
      `,
    }
};

const JoinTeamAndPodcasts: FC<OwnProps> = ({ id }) => {
    return (
     
        <StyledWrapper {...styles.wrapper}>
            <StyledWrapper {...styles.joinTeamContainer}>
              <Zone zoneName="RichContent1" contentId={id} />
            </StyledWrapper>
            <StyledWrapper {...styles.PodcastsContainer}>
              <Zone zoneName="RichContent2" contentId={id} />
            </StyledWrapper>
        </StyledWrapper>
     
    );
};

const widgetModule: WidgetModule = {
    component: JoinTeamAndPodcasts,
    definition: {
        group: "Common",
        displayName: "JoinTeamAndPodcasts",
    },
};

export default widgetModule;
